module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kk-La.2a7d3696.png";